module.exports = __webpack_public_path__ + "img/img_display_6.74faa6cc.svg";